<ng-container>
  <div class="ctrl-select">
    <a mat-button [disabled]="allSelected" (click)="selectAll()" data-testid="select-all">
      <mat-icon fontIcon="check"></mat-icon>
      {{ selectAllLabel }}</a>
  </div>
  <div class="ctrl-select">
    <a mat-button [disabled]="singleSelected" (click)="selectNone()" data-testid="select-none">
      <mat-icon fontIcon="clear"></mat-icon>
      {{ noneLabel }}</a>
  </div>
</ng-container>
